// extracted by mini-css-extract-plugin
export default {"termsOfUse":"TermsOfUse_termsOfUse__oVIMM","topHeader":"TermsOfUse_topHeader__0SGTW","lastUpdated":"TermsOfUse_lastUpdated__bulIR","keyPoints":"TermsOfUse_keyPoints__L3DhY"};